import axios from 'axios';
import https from 'https'; // Importer le module https

const API_URL = `${process.env.REACT_APP_API_URL}/admins`; // L'URL de ton API

// Créer un agent HTTPS pour ignorer les erreurs de certificat
const httpsAgent = new https.Agent({  
  rejectUnauthorized: false // Ignorer les erreurs de certificat auto-signé
});

// Fonction pour la connexion
export const loginAdmin = async (email, password) => {
    const response = await axios.post(
      `${API_URL}/login`, 
      { email, password },
      { httpsAgent }  // Ajouter l'agent HTTPS ici
    );
    return response.data;
};

// Fonction pour l'inscription
export const signupAdmin = async (email, password) => {
    const response = await axios.post(
      `${API_URL}/signup`, 
      { email, password },
      { httpsAgent }  // Ajouter l'agent HTTPS ici
    );
    return response.data;
};
